import {useLocation} from "react-router-dom";

// ----------------------------------------------------------------------

export default function GetQueryParam(param) {
    const search = useLocation().search;
    return new URLSearchParams(search).get(param);
}